// Options '{'width':450,'height':535}'
export function getPosition(options) {
  const width = options.width;
  const height = options.height;
  let left;
  let top;

  if (width) {
    if (window.outerWidth) {
      left = Math.round((window.outerWidth - width) / 2) + window.screenX;
    } else if (window.screen.width) {
      left = Math.round((window.screen.width - width) / 2);
    }
  }

  if (height) {
    if (window.outerHeight) {
      top = Math.round((window.outerHeight - height) / 2) + window.screenY;
    } else if (window.screen.height) {
      top = Math.round((window.screen.height - height) / 2);
    }
  }

  return {
    x: left,
    y: top,
  };
}

export function getActualDomain(win) {
  return `${win.location.protocol}//${win.location.host}`;
}

export function getDomain(passedWin) {
  const win = passedWin || window;

  if (!win.location.protocol) {
    throw new Error(`Can not read window protocol`);
  }

  if (win.location.protocol === "file") {
    return getActualDomain(win);
  }

  if (!win.location.host) {
    throw new Error(`Can not read window host`);
  }

  return getActualDomain(win);
}

export function isSameDomain(win) {
  try {
    return getDomain(window) === getDomain(win);
  } catch (err) {
    return false;
  }
}

function safeGet(obj, prop) {
  let result;
  try {
    result = obj[prop];
  } catch (err) {
    // pass
  }
  return result;
}

export function isWindowClosed(win, allowMock = true) {
  try {
    if (win === window) {
      return false;
    }
  } catch (err) {
    return true;
  }

  try {
    if (!win) {
      return true;
    }
  } catch (err) {
    return true;
  }

  try {
    if (win.closed) {
      return true;
    }
  } catch (err) {
    // I love you so much IE
    if (err && err.message === "Call was rejected by callee.\r\n") {
      return false;
    }
    return true;
  }

  if (allowMock && isSameDomain(win) && safeGet(win, "mockclosed")) {
    return true;
  }

  // Mobile safari
  try {
    if (!win.parent || !win.top) {
      return true;
    }
  } catch (err) {
    // pass
  }

  return false;
}

export function popup(url, options) {
  const params = Object.keys(options)
    .map(key => {
      if (options[key]) {
        return key + "=" + options[key];
      }
    })
    .filter(Boolean)
    .join(",");

  const win = window.open(url, options.name, params, !0);

  if (isWindowClosed(win)) {
    throw new Error("Can not open popup window - blocked");
  }
  return win;
}

function getInitialDimensions() {
  return {
    width: 300,
    height: 397,
  };
}

export function cleanupWindow(win) {
  if (win) {
    win.close();
  }
}

export function openPopupWindow({ url, closeCallback }) {
  const { width, height, x, y } = getInitialDimensions();

  const pos = getPosition({ width, height, x, y });
  const win = popup(url, {
    name: "payment",
    width,
    height,
    top: pos.y,
    left: pos.x,
    status: 1,
    toolbar: 0,
    menubar: 0,
    resizable: 1,
    scrollbars: 1,
  });

  const interval = window.setInterval(() => {
    try {
      if (!win || win.closed) {
        window.clearInterval(interval);
        closeCallback(win);
      }
    } catch (error) {
      console.log("Error closing window" + error);
    }
  }, 1000);

  return win;
}
